import React, {useState} from "react";
import Headerk from "./component/headerk";
import Mainpage from "./component/iconspage";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";


function Settingsk(){
    const [topTab, setTopTab] = useState("Settings"); // ✅ Add state

    return(
        <DashboardLayout>
            <DashboardNavbar/>
        <Headerk topTab={topTab} setTopTab={setTopTab} />
        <Mainpage />

        </DashboardLayout>
    )
};

export default Settingsk;
